import { Box, Button, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { ButtonColor } from 'shared/Button';
import { ModalTopUp } from 'shared/Modals';
import RootModalLayout from 'shared/Modals/RootModalLayout';
import { useTheme } from 'themes/themeProvider';
import { ThemeKey } from 'types/general.types';

interface AddMinerModalProps {
  onClose: () => void;
}

export const AddMinerModal: FC<AddMinerModalProps> = ({ onClose }) => {
  const { themeKey } = useTheme();

  const [isPopupOpened, setIsPopupOpened] = useState(false);

  const topUpHandler = () => setIsPopupOpened(!isPopupOpened);

  const shouldShowTopUp =
    themeKey === ThemeKey.CRYPTOHALL24_DUERR ||
    themeKey === ThemeKey.CRYPTOHALL24_QUETTA ||
    themeKey === ThemeKey.PANTHEON ||
    themeKey === ThemeKey.AVATRON ||
    themeKey === ThemeKey.PANTHEON_AUS ||
    themeKey === ThemeKey.AMITYAGE;

  return (
    <>
      <RootModalLayout onClose={onClose} title='Coming very soon!'>
        <section>
          <Box mt={2}>
            {
              <Typography variant='body1' gutterBottom>
                Soon, you&apos;ll be able to explore the latest miners and purchase them directly from your dashboard.
                Place orders to start mining within minutes, or secure preorders for upcoming models. Easily track your
                delivery, activation, and all other essential details about your new miners—right from your dashboard.
              </Typography>
            }
          </Box>

          {shouldShowTopUp && (
            <Box mt={2} display='flex' justifyContent='end'>
              <Button variant='contained' color={ButtonColor.SECONDARY} onClick={topUpHandler}>
                Top up balance
              </Button>
            </Box>
          )}
        </section>
      </RootModalLayout>
      {isPopupOpened && <ModalTopUp isOpen={isPopupOpened} onClose={topUpHandler} />}
    </>
  );
};
